import { render, staticRenderFns } from "./CreateModality.vue?vue&type=template&id=2c8d2340"
import script from "./CreateModality.vue?vue&type=script&lang=js"
export * from "./CreateModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports